import localeOrigin from '../base/locale-module/locale-origin.js';

export default localeOrigin;